import React from 'react';

interface KlarnaIconProps {
  width?: number | string;
  height?: number | string;
  className?: string;
  style?: React.CSSProperties;
}

export const KlarnaIcon: React.FC<KlarnaIconProps> = ({
  width = 24,
  height = 24,
  className,
  style,
}) => {
  return (
    <svg
      aria-label="Klarna"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
      style={{ display: 'inline-block', verticalAlign: 'middle', ...style }}
    >
      <rect width="24" height="24" rx="4" fill="#FFB3C7" />
      <path
        fill="#0A0B09"
        d="M13.5 5.5H11.8c0 1.7-.8 3.3-2.1 4.3L8.5 11l3.6 4.8h2.3l-3.3-4.5c1.5-1.4 2.4-3.4 2.4-5.8zm-1.4 11.3c0 .7.6 1.2 1.2 1.2.7 0 1.2-.5 1.2-1.2 0-.7-.5-1.2-1.2-1.2-.6 0-1.2.5-1.2 1.2zM5.5 5.5h1.7v10.3H5.5V5.5z"
      />
    </svg>
  );
};
